<template>
  <div>
    <div class="pageloader is-active has-text-centered">
      <span class="title" />
    </div>
  </div>
</template>

<script>

export default {
  created () {

    // on récupère un éventuel initSearch depuis l'URL et on le stocke dans le store state si il existe
    var initSearch = readinitSearchUrlHashParams()
    if (initSearch)
      this.$store.dispatch('setInitSearch', { 'initSearch': initSearch })
    else
      this.$store.dispatch('setInitSearch', { 'initSearch': '' })


    // on récupère un éventuel token depuis l'URL et on le stocke dans le store state si il existe
    var tokenURL = readUrlHashParams()
    if (tokenURL)
      this.$store.dispatch('setTokenURL', { 'tokenURL': tokenURL })
    // On teste si le token  est vide dans le store (vide = pas de token en URL ou pas de token en mémoire localstorage) - on  vire le gars vers APPYPACK
    if (!this.$store.getters.userToken) {
      window.location = process.env.VUE_APP_URL_SSO_FRONT
      return
    }
    else {
      // on fait une demande de récupération de user/me avec ce token de connexion 'mis à jour ou en mémoire'	
      this.$store.dispatch('requireAuth')
      return
    }
  }
}



function readUrlHashParams () {
  var tokenTrouve = false;
  var hashParam = window.location.href.split('?')[1];
  if (hashParam) {
    var params = hashParam.split("&");
    params.forEach(function (element) {
      var paramSet = element.split("=");
      if (paramSet[0] == "t") {
        tokenTrouve = paramSet[1]
      }
    });
  }
  return tokenTrouve
}

function readinitSearchUrlHashParams () {
  var initSearchTrouve = false;
  var hashParam = window.location.href.split('?')[1];
  if (hashParam) {
    var params = hashParam.split("&");
    params.forEach(function (element) {
      var paramSet = element.split("=");
      if (paramSet[0] == "initSearch") {
        initSearchTrouve = paramSet[1]
      }
    });
  }
  return initSearchTrouve
}



</script>

<style type="text/css" scoped>
.pageloader {
  background: #424a60;
}
</style>
